import styled from 'styled-components';
import theme from 'styled-theming';
import { rem } from 'polished';
var avatarSize = theme('size', {
  small: rem(12),
  medium: rem(16),
  large: rem(24),
  xlarge: rem(32),
  xxlarge: rem(40)
});
export var StyledAvatarGroup = styled.div.withConfig({
  displayName: "AvatarGroupstyles__StyledAvatarGroup",
  componentId: "sc-1sk5m9c-0"
})(["display:flex;align-items:center;"]);
export var StyledAvatarMore = styled.div.withConfig({
  displayName: "AvatarGroupstyles__StyledAvatarMore",
  componentId: "sc-1sk5m9c-1"
})(["width:", ";height:", ";align-items:center;color:var(--dentsu-color-t800);font-weight:500;justify-content:center;border-radius:50%;border:none !important;display:flex;font-size:calc(", " / 2.5);"], avatarSize, avatarSize, avatarSize);